import { Card } from "primereact/card";
import "../account-manager.scss";
import ManagedEntitiesTable from "./ManagedEntitiesTable";
import { useState } from "react";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES_V2 from "~/api-routes-v2";
import { useOutletContext } from "react-router-dom";
import { OutletContext } from "~/Pages/Tenants/types/tenants";
import AdminOnly from "~/components/AdminOnly";
import CustomeButton from "~/components/Button";
const ManagedEntities = () => {
  const { managerId } = useOutletContext<OutletContext>();
  const [isAuditSidebarVisible, setIsAuditSidebarVisible] = useState(false);
  const auditLabels = () => {
    return {
      assign: "Entity Assigned",
      remove: "Entity Unassigned",
    };
  };
  return (
    <>
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Managed Entities"
          endpoint={API_ROUTES_V2.FETCH_ACCOUNT_MANAGER_ENTITIES_AUDIT}
          id={managerId}
          labels={auditLabels}
          setSidebarToggle={setIsAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
        />
      )}
      <Card className="managed-entities-card">
        {/* Header */}
        <div className="header flex justify-content-between">
          <div className="flex flex-column gap-2">
            <p className="title m-0"> Managed Entiites </p>
            <p className="description m-0">
              Find all the entities managed by this account manager.
            </p>
          </div>
          <AdminOnly>
            <div className="flex gap-2">
              <CustomeButton
                label="View History"
                icon="pi pi-history"
                iconPos="right"
                variant="outlined"
                className="edit-btn"
                onClick={() => setIsAuditSidebarVisible(true)}
              />
            </div>
          </AdminOnly>
        </div>

        {/* Table */}
        <ManagedEntitiesTable />
      </Card>
    </>
  );
};

export default ManagedEntities;
